import React, { useState } from "react";
import { Form, Modal, Button, Container } from "react-bootstrap";

import styles from "../../generic/css/Table.module.css";
import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";

import { useSiteContext } from "../Providers/SSCProvider";
import useApi from "../../../apiProvider";

const AddTempStructureModal = ({ modalData, setModalData }) => {
  const { selectedSite, selectEmptyStructure, rebuildHierarchy } =
    useSiteContext();

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const closeModal = () => {
    setModalData({ show: false, structureName: "" });
  };

  const submitTempStructure = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!modalData.structureName?.trim()) {
      newErrors.structureName = "Temp Structure Name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    const results = await useApi.createTempStructure({
      siteId: selectedSite.siteId,
      structureId: null,
      structureName: modalData.structureName,
      structureCountry: selectedSite.country,
      structureCity: selectedSite.city,
    });

    const returnedStructures = results?.returnData?.returnedStructures;
    const savedStructure = results?.returnData?.savedStructure[0];

    if (!returnedStructures || !savedStructure) {
      setIsLoading(false);
      return;
    }

    rebuildHierarchy({ structures: returnedStructures });

    selectEmptyStructure(savedStructure.structureId, returnedStructures);

    setIsLoading(false);
    closeModal();
  };

  return (
    <Container>
      <Modal
        show={modalData.show}
        onHide={closeModal}
        centered
        dialogClassName="custom-modal"
        size="lg"
        scrollable
      >
        {isLoading && <div className={styles["overlay"]} />}

        <div className="mt-4 mb-2 ps-4">
          <Modal.Title>
            Add Temp Structure To Site: {selectedSite?.siteId} –{" "}
            {selectedSite?.siteName}
          </Modal.Title>
        </div>

        <Modal.Body style={{ overflowY: "auto" }}>
          <Form onSubmit={submitTempStructure}>
            <Form.Group className="mb-3" controlId="structureName">
              <Form.Label>Temp Structure Name</Form.Label>
              <Form.Control
                type="text"
                disabled={isLoading}
                placeholder="Enter Temp Structure Name *"
                value={modalData.structureName || ""}
                isInvalid={!!errors.structureName}
                onChange={(e) => {
                  setModalData((prev) => ({
                    ...prev,
                    structureName: e.target.value,
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    structureName: undefined,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.structureName}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="mt-3">
          <Button
            disabled={isLoading}
            style={{
              width: "80px",
              color: "#707782",
              backgroundColor: "#E5E7EB",
              border: "none",
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>

          <Button
            className="cursorButton"
            onClick={submitTempStructure}
            disabled={isLoading}
            style={{
              width: "80px",
              color: "#FFFFFF",
              backgroundColor: "#198754",
              border: "none",
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddTempStructureModal;
